import React, { useState } from "react";
import axios from "axios";
import "./StoryModal.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import API_BASE_URL from "../../../utils/apiUtils";

function StoryModal({ isOpen, onClose, addNewStory }) {
  const [description, setDescription] = useState("");
  const [name, setName] = useState("");
  const [title, setTitle] = useState("");
  const [likes, setLikes] = useState(0);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newStory = {
      name,
      title,
      description,
      likes,
    };

    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/stories`,
        newStory
      );
      console.log("Story added successfully:", response.data);

      // Add new story to the list.
      addNewStory(response.data);

      // Clear form fields after successful submission
      setName("");
      setTitle("");
      setDescription("");
      setLikes(0);
      onClose(); // Close the modal after submission
    } catch (error) {
      console.error("There was an error adding the story:", error);
    }
  };

  if (!isOpen) return null;

  return (
    <div className={`story-modal ${isOpen ? "is-active" : ""}`}>
      <div className="story-modal__content">
        <span className="story-modal__close-x" onClick={onClose}>
          &times;
        </span>
        <form onSubmit={handleSubmit}>
          <div>
            <label className="story-modal__label" htmlFor="name">
              Name:
            </label>
            <input
              className="story-modal__input"
              type="text"
              id="name"
              name="name"
              value={name}
              placeholder="Enter your name..."
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>
          <div>
            <label className="story-modal__label" htmlFor="title">
              Title:
            </label>
            <input
              className="story-modal__input"
              type="text"
              id="title"
              name="title"
              value={title}
              placeholder="Enter the title of your story..."
              onChange={(e) => setTitle(e.target.value)}
              required
            />
          </div>
          <div>
            <label className="story-modal__label" htmlFor="description"></label>
            <textarea
              className="story-modal__description"
              id="description"
              name="description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Enter your story here..."
              required
            ></textarea>
          </div>

          <button
            type="submit"
            className="story-modal__submit button is-primary"
          >
            Submit Story
          </button>
        </form>
      </div>
      <button
        className="modal-close is-large"
        aria-label="close"
        onClick={onClose}
      ></button>
    </div>
  );
}
export default StoryModal;
